import React, { useState, useEffect } from 'react';
import config from '../config.json';
import axios from '../utils/axiosInstance';
import io from 'socket.io-client';
import { useNavigate } from 'react-router-dom';
import { styled, Card, CardHeader, CardContent, Typography, Checkbox, CardActions, IconButton, Menu, MenuItem, Collapse, List, ListItem, ListItemIcon, ListSubheader, ListItemButton, ListItemText, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField, FormControlLabel } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AssignmentIcon from '../assets/Chart.svg';
import addgroup from '../assets/Add.svg';
import EditIcon from '../assets/Pencil.svg';
import TrashIcon from '../assets/trash.svg';
import ActivityGroupingIcon from '../assets/group.svg';
import { Button } from '@mui/base';
import { Button as MuiButton } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { sendMessage } from '../utils/socketTool';
import { findroomByInfo } from '../utils/findRoomMode';
import url from '../url.json';
import RoomSettingsChatroomIcon from "../assets/RoomSettings/chatroom.png";
import RoomSettingsPostIcon from "../assets/RoomSettings/posts.png";
import RoomSettingsMindmapIcon from "../assets/RoomSettings/mindmap.png";
import ActivitySettingsDialog from './Admin/ActivitySettingsDialog';


const Item = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#E3DFFD',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  color: theme.palette.text.secondary,
}));

const EnterActivity = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme }) => ({
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

const getIconByLabel = (label) => {
  switch (label) {
    case "mindmap":
      return RoomSettingsMindmapIcon;
    case "chatroom":
      return RoomSettingsChatroomIcon;
    case "posts":
    return RoomSettingsPostIcon;
    default:
      return null;
  }
}
const ITEM_HEIGHT = 48;



export default function MyCreatedActivityCard({ activity }) {
  const ws = io.connect(url.socketioHost,{path: '/s/socket.io'});
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const [groupData, setGroupData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedModal, setSelectedModal] = useState(null);
  const [selectedModalOpen, setSelectedModalOpen] = useState(false);
  const [hiddenGroups, setHiddenGroups] = useState(JSON.parse(localStorage.getItem('hiddenGroups') || '{}'));
  const [openCreateGroupDialog, setOpenCreateGroupDialog] = useState(false);
  const [openSettingOfActivity, setOpenSettingOfActivity] = useState(false);
  const [numGroupsToCreate, setNumGroupsToCreate] = useState(1);
  const [creatingGroups, setCreatingGroups] = useState(false);
  const [roomSetting, setRoomSetting] = useState(null);

  const open = Boolean(anchorEl);

  // 修改 createGroup 函數以接受數量參數
  const createGroup = async (num) => {
    if (num < 1) {
      alert("請輸入至少1個小組數量");
      return;
    }
  
    try {
      // 先獲取現有的小組數量
      const response = await axios.get(
        url.backendHost + config.findAllGroup + localStorage.getItem('activityId')
      );
  
      const existingGroups = response.data.Groups;
      const nextGroupNumber = existingGroups.length + 1;
  
      // 逐一創建小組
      for (let i = 0; i < num; i++) {
        const groupName = `第${nextGroupNumber + i}組`;
        const groupData = {
          groupName,
          activityId: localStorage.getItem('activityId'),
          numGroups: 1,
          userId: localStorage.getItem('userId'),
        };
  
        const res = await axios.post(url.backendHost + config.creatGroup, groupData);
  
        // 加入該小組
        const joinData = {
          userId: localStorage.getItem('userId'),
        };
  
        await axios.put(
          `${url.backendHost + config.joinActivity}/${res.data.groups[0].joinCode}/join`,
          joinData
        );
      }
  
      sendMessage(ws); // ✅ 通知 socket 有新小組
      alert(`${num} 個小組新增成功`);

      setAnchorEl(null);
      setExpanded(false);
      getGroups(); // 重新抓取最新小組
      
      // 更新 JWT token
      try {
        const tokenResponse = await axios.get(url.backendHost + config.renewToken);
        if (tokenResponse.data && tokenResponse.data.jwtToken) {
          localStorage.setItem('jwtToken', tokenResponse.data.jwtToken);
          console.log('JWT token updated successfully');
        }
      } catch (tokenError) {
        console.error('Failed to renew JWT token:', tokenError);
      }
  
    } catch (error) {
      alert("新增小組失敗");
      if (error.response) {
        console.error("Server responded with error:", error.response);
      } else if (error.request) {
        console.error("Network error:", error.request);
      } else {
        console.error("Error:", error.message);
      }
    }
  };
  

  const editClassSetting = () => {
    getActivityInfo().then((response) => {
      console.log("Room Settings", roomSetting);
      if (response && response.data=='') {
        // if no settings, new a activity info for this activity
        postActivityInfo().then((initResponse) => {
          console.log("initResponse", initResponse);
          setRoomSetting(initResponse.data.settings);
          setOpenSettingOfActivity(true);
        });
        
      }else{
        
        setRoomSetting(response.data.settings);
        setOpenSettingOfActivity(true);
      }
    });

  };

  const options = [
    { text: '派發活動任務', modalKey: 'enterPageOfPrepareLesson', icon: EditIcon },
    { text: '新增小組', onClick: () => setOpenCreateGroupDialog(true), icon: addgroup },
    { text: '設定活動聊天室', onClick: editClassSetting, icon: EditIcon },
    { text: '儀表板分析', onClick: () => navigate('/dashboard'), icon: AssignmentIcon },
    //{ text: '課堂任務', modalKey: '', icon:  },
    //{ text: '學生分組', modalKey: 'activityGrouping', icon: ActivityGroupingIcon },
    //{ text: '編輯活動資訊', modalKey: 'editInformationOfActivity', icon: EditIcon },
    //{ text: '刪除', modalKey: 'deleteActivity', icon: TrashIcon },

  ];

  const handleClickMore = async (event) => {
    setAnchorEl(event.currentTarget);
    localStorage.setItem('activityId', activity.id);
    try {
      const fetchData = await axios.get(url.backendHost + config.findAllGroup + activity.id);
      const groupIds = fetchData.data.Groups.map(group => group.id).sort((a, b) => a - b);
      localStorage.setItem('groupIds', JSON.stringify(groupIds));
      // 找到 user 剛加入的小組 id
      let myGroupId = null;
      if (fetchData.data.Groups && fetchData.data.Groups.length > 0) {
        // 以 userId 判斷 user 所屬 group
        const userId = localStorage.getItem('userId');
        const myGroup = fetchData.data.Groups.find(group => {
          if (!group.Users) return false;
          return group.Users.some(user => String(user.id) === String(userId));
        });
        if (myGroup) {
          myGroupId = myGroup.id;
        } else {
          // fallback: 預設第一個 group
          myGroupId = groupIds[0];
        }
      }
      if (myGroupId) {
        localStorage.setItem('groupId', myGroupId);
      } else {
        localStorage.removeItem('groupId'); // 清空 groupId
      }

      // 同時將localStorage資料全部傳給sessionStorage
      for (const key in localStorage) {
        if (localStorage.hasOwnProperty(key)) {
          const value = localStorage.getItem(key);
          sessionStorage.setItem(key, value);
        }
      }
    } catch (err) {
      console.error("Error fetching groups:", err);
    }
  };

  

  const handleCloseMore = () => {
    setAnchorEl(null);
  };

  const openModal = (modalKey) => {
    setSelectedModal(modalKey);
    setSelectedModalOpen(true);
  };

  const closeModal = () => {
    setSelectedModal(null);
    setSelectedModalOpen(false);
  };

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
    localStorage.setItem('activityId', activity.id);
    setSelectedModal(null);
  };

  const initWebSocket = () => {
    ws.on('connect', () => {
      // console.log("WebSocket connected");
    });

    ws.on('event02', (arg, callback) => {
      // console.log("WebSocket event02", arg);
      callback({
        status: 'event02 ok',
      });
    });
  };
  const getActivityInfo= async () => await axios.get(url.backendHost +'api/activityInfo/' + localStorage.getItem('activityId')).then((response) => {
      localStorage.setItem('activityInfo', JSON.stringify(response.data));
      console.log("getActivityInfo", response);
      return response
    });
  
  const postActivityInfo= async () => await axios.post(url.backendHost +'api/activityInfo/',{
      activityId: localStorage.getItem('activityId'),
      userId: localStorage.getItem('userId'),
    }).then((response) => {
      console.log("postActivityInfo", response);
      return response
    });
  const putActivityInfo = async (roomSetting) => {
    try {
      await axios.put(url.backendHost +'api/activityInfo/'+ localStorage.getItem('activityId'),{
        activityId: localStorage.getItem('activityId'),
        userId: localStorage.getItem('userId'),
        settings: roomSetting
      }).then((response) => {
        console.log("putActivityInfo", response);
        return response
      });
    } catch (err) {
      alert("Error updating activity info: Json Error");
      console.error("Error:", err);
    }
  }

  

  useEffect(() => {
    const ws = io.connect(url.socketioHost,{path: '/s/socket.io'});
    initWebSocket(ws);

    return () => {
      ws.disconnect();
    };
  }, []);

  const getGroups = async () => {
    try {
      const fetchData = await axios.get(url.backendHost + config.findAllGroup + localStorage.getItem('activityId'));
      console.log("GroupData: ", fetchData.data.Groups);
      const sortedGroups = fetchData.data.Groups.sort((a, b) => 
        a.groupName.localeCompare(b.groupName, 'zh-Hant', { numeric: true })
      );
      setGroupData(sortedGroups);
      
    } catch (err) {
      // console.log(err);
    }
  };
  

  const handleExpandClick = () => {
    setExpanded(!expanded);
    localStorage.setItem('activityId', activity.id);
    getGroups();
  };

  const formatTimestamp = (timestamp) => {
    return new Intl.DateTimeFormat('zh-TW', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      //   second: 'numeric',
      hour12: false,
    }).format(new Date(timestamp));
  };


  const handleEnter = async (e, groupId, joinCode) => {
    e.preventDefault();
    
    localStorage.setItem('activityId', activity.id);

    try {
      await axios.get(`${url.backendHost + config.EnterDifferentGroup}${joinCode}/${localStorage.getItem('userId')}`);
    } catch (error) {
      if (error.response) {
        console.error("Server responded with error:", error.response);
      } else if (error.request) {
        console.error("Network error:", error.request);
      } else {
        console.error("Error:", error.message);
      }
    }

    // 將基本資訊複製到 sessionStorage
    sessionStorage.setItem('activityId', activity.id);
    sessionStorage.setItem('userId', localStorage.getItem('userId'));
    sessionStorage.setItem('jwtToken', localStorage.getItem('jwtToken'));

    getActivityInfo()
      .then((activityInfo) => {
          console.log("getActivityInfo", activityInfo);
          // 使用 URL 參數傳遞小組資訊，避免 localStorage 衝突
          const baseUrl = findroomByInfo(activityInfo);
          const urlWithParams = `${baseUrl}?groupId=${groupId}&joinCode=${joinCode}`;
          window.open(urlWithParams, '_blank');
      })
      .catch((error) => {
          console.error(error);
          const urlWithParams = `/forum?groupId=${groupId}&joinCode=${joinCode}`;
          window.open(urlWithParams, '_blank');
      });
  };
  const toggleGroupVisibility = (groupId) => {
    const updatedHiddenGroups = { ...hiddenGroups, [groupId]: !hiddenGroups[groupId] };
    setHiddenGroups(updatedHiddenGroups);
    localStorage.setItem('hiddenGroups', JSON.stringify(updatedHiddenGroups));
  };

  const showAllHiddenGroups = () => {
    const updatedHiddenGroups = {};
    setHiddenGroups(updatedHiddenGroups);
    localStorage.setItem('hiddenGroups', JSON.stringify(updatedHiddenGroups));
  };
  return (
    <div>
      <Item>
        <CardHeader
          action={
            <>
              <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClickMore}
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                id="long-menu"
                MenuListProps={{
                  'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleCloseMore}
                PaperProps={{
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: '20ch',
                  },
                }}
              >
                {options.map((option, index) => (
                  <MenuItem key={index} onClick={() => { 
                    if (option.modalKey) {
                      openModal(option.modalKey); 
                    }
                    if (option.onClick) {
                      option.onClick(); 
                    }
                  }}>
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        maxWidth: 24,
                        mr: open ? 3 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      <img alt='' src={option.icon} />
                    </ListItemIcon>
                    <ListItemText primary={option.text} sx={{ opacity: open ? 1 : 0 }} style={{ color: '#8B8B8B' }} />
                  </MenuItem>
                ))}
              </Menu>
            </>
          }
          title={activity.title}
        />
        <CardContent>
          <Typography variant="body2" color="text.secondary">
            {`${formatTimestamp(activity.startDate)} ~ ${formatTimestamp(activity.endDate)}`}
          </Typography>
        </CardContent>
        <CardActions disableSpacing>
          <div style={{ marginRight: 'auto' }}>
            <Button className='enter-activity-button' onClick={handleExpandClick}>
              展開小組列表 ▼ 
            </Button>
          </div>
        </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <List
            subheader={
              <ListSubheader component="div" id="nested-list-subheader" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                小組列表
                <Button className='hidden-button' onClick={showAllHiddenGroups}>
                  顯示所有隱藏小組
                </Button>
              </ListSubheader>
            }
          >
            {groupData.map((group) => (
              !hiddenGroups[group.id] && (
                <ListItem
                  key={group.joinCode}
                  disablePadding
                  secondaryAction={
                    <EnterActivity>
                      <Button 
                        className='enter-activity-button' 
                        onClick={(e) => { 
                          handleEnter(e, group.id, group.joinCode); 
                        }}
                        data-group-id={group.id}
                        data-join-code={group.joinCode}
                      >
                        進入小組
                      </Button>
                      <Button 
                        className='hidden-button' 
                        onClick={() => toggleGroupVisibility(group.id)} 
                        style={{ background: '#e3dffd', fontSize:"24px" }}>
                        x
                      </Button>
                    </EnterActivity>
                  }
                >
                  <ListItemButton>
                    <ListItemText primary={group.groupName} secondary={"小組邀請碼：" + group.joinCode} />
                  </ListItemButton>
                </ListItem>
              )
            ))}
          </List>
        </Collapse>
      </Item>

      {/* 新增小組對話框 */}
      <Dialog open={openCreateGroupDialog} onClose={() => setOpenCreateGroupDialog(false)}>
        <DialogTitle>新增小組</DialogTitle>
        <DialogContent>
          <DialogContentText>
            請輸入要新增的小組數量：
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="numGroups"
            label="小組數量"
            type="number"
            fullWidth
            variant="standard"
            value={numGroupsToCreate}
            onChange={(e) => setNumGroupsToCreate(parseInt(e.target.value, 10))}
            inputProps={{ min: 1 }}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2.5, bgcolor: '#f8f9fa', borderTop: '1px solid #e0e0e0' }}>
          <MuiButton onClick={() => setOpenCreateGroupDialog(false)}>
            取消
          </MuiButton>
          <MuiButton 
            onClick={async () => {
              setCreatingGroups(true);
              await createGroup(numGroupsToCreate);
              setCreatingGroups(false);
              setOpenCreateGroupDialog(false);
              setNumGroupsToCreate(1); 
            }}
            disabled={creatingGroups}
            variant="contained"
          >
            {creatingGroups ? '新增中...' : '確認'}
          </MuiButton>
        </DialogActions>
      </Dialog>

      {/* 活動室設定對話框 */}
      <ActivitySettingsDialog
        open={openSettingOfActivity}
        onClose={() => setOpenSettingOfActivity(false)}
        roomSetting={roomSetting}
        setRoomSetting={setRoomSetting}
        saveSettings={putActivityInfo}
        getIconByLabel={getIconByLabel}
      />

      {selectedModal === 'enterPageOfPrepareLesson' && (
        navigate('/teacher/pageOfPrepareLesson')
      )}
      {/* {selectedModal === 'editInformationOfActivity' && (
            <CreateIdea
                open={openModal}
                onClose={closeModal}
            />
        )}
        {selectedModal === 'editInformationOfActivity' && (
            <CreateIdea
                open={openModal}
                onClose={closeModal}
            />
        )} */}
    </div>
  );
}